import React from 'react'

import { Container } from './styles'

const EmptyApproverCard = () => {
  return (
    <Container>
      <p>Nenhum responsável por aprovação adicionado ainda.</p>
    </Container>
  )
}

export default EmptyApproverCard
